// extracted by mini-css-extract-plugin
export default {"input":"Input_input__V4Qm5"};